import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Modal } from 'bootstrap';
import { DocumentViewerService, DocumentViewerState } from '../../services/document-viewer.service';
import { AppFile } from '../../models/app-file.model';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.css']
})
export class DocumentViewerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('documentViewerModal') modalElement?: ElementRef<HTMLDivElement>;

  state: DocumentViewerState = {
    isOpen: false,
    document: null,
    contentUrl: null,
    isImage: false,
    error: null
  };

  private modal?: Modal;
  private stateSubscription?: Subscription;

  constructor(private readonly viewerService: DocumentViewerService) {}

  ngOnInit(): void {
    this.stateSubscription = this.viewerService.state$.subscribe(state => {
      this.state = state;
      if (this.modal) {
        state.isOpen ? this.modal.show() : this.modal.hide();
      }
    });
  }

  ngAfterViewInit(): void {
    if (!this.modalElement) return;
    this.modal = Modal.getOrCreateInstance(this.modalElement.nativeElement, {
      backdrop: 'static'
    });
    if (this.state.isOpen) {
      this.modal.show();
    }
  }

  ngOnDestroy(): void {
    this.stateSubscription?.unsubscribe();
    this.modal?.dispose();
  }

  close(): void {
    this.viewerService.close();
  }

  download(document: AppFile): void {
    this.viewerService.download(document);
  }
}
